import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'typings/RootState'
import styled from 'styled-components'
import { Button, Col } from 'antd'

import { getUnitList, getQCTypeList } from 'features/filter/api'
import { GetUnitListReq, GetQCTypeListReq } from 'features/filter/types'
import { selectUnitList, selectQCTypeList } from 'features/filter/selector'
import { selectedProjectCodeSelector } from 'features/project/project.selector'
import {
  serviceTokenSelector,
  userEmailSelector,
} from 'features/sensitive/sensitive.selector'

import { selectFilter } from 'features/cmpj/qcdashboard/selector'
import { Filter } from 'features/cmpj/qcdashboard/types'
import { updateFilter } from 'features/cmpj/qcdashboard/actions'

import { getLeafWbsList } from 'features/wbs/wbs.function'
import { getWbsListSelector } from 'features/wbs/wbs.selector'

import { WbsFilter, UnitFilter, QCTypeFilter } from './Components'
import { JsonParam, useQueryParam } from 'use-query-params'
import { useLocation } from 'react-router'
import queryString from 'query-string'

type Props = {
  onSearch?: () => void
  withPadding?: boolean
} & ReduxProps &
  DispatchProps

const CMUnitFilter: React.FunctionComponent<Props> = props => {
  const {
    ProjectCode,
    UserEmail,
    token,
    unitList,
    filter,
    onSearch = () => {},
    withPadding = false,
    qctypeList,
    wbsList,
  } = props

  const [search, setSearch] = useQueryParam('search', JsonParam)
  const searchParam = useLocation()

  useEffect(() => {
    onGetUnitList()
    onGetQCTypeList()

    onBindFilterFromParams()
  }, [ProjectCode, UserEmail, searchParam.search])

  const onBindFilterFromParams = () => {
    if (searchParam.search) {
      const param = queryString.parse(searchParam.search)
      const activityFilter: Filter = JSON.parse(param.search!.toString())
      onFilterChange(activityFilter)
      setSearch(activityFilter)
      onSearch()
    }
  }

  const onGetUnitList = () => {
    const req: GetUnitListReq = {
      ProjectCode,
      UserEmail,
      Zone: 'Resident Area',
    }
    dispatch(getUnitList(token, req))
  }

  const onGetQCTypeList = () => {
    const req: GetQCTypeListReq = {
      UserEmail,
      UnitType: 'Unit',
      Status: 'Active',
    }
    dispatch(getQCTypeList(token, req))
  }

  const dispatch = useDispatch()
  const onFilterChange = (filter: Filter) => {
    dispatch(updateFilter(filter))
  }

  const onClick = () => {
    filter.LeafWbsList = getLeafWbsList(wbsList, filter.WbsList)
    dispatch(updateFilter(filter))
    setSearch(filter)
    onSearch()
  }

  return (
    <MainPage className={withPadding ? 'with-padding' : ''}>
      <div className="filters">
        <Col span={24} className="filters-button">
          <WbsFilter
            onFilterChange={onFilterChange}
            filter={filter}
            wbsList={wbsList}
          />

          <UnitFilter
            onFilterChange={onFilterChange}
            filter={filter}
            unitList={unitList.List}
          />

          <QCTypeFilter
            onFilterChange={onFilterChange}
            filter={filter}
            qctypeList={qctypeList.List}
          />
          <Button type="primary" onClick={onClick}>
            กรองข้อมูล
          </Button>
        </Col>
      </div>
    </MainPage>
  )
}

const MainPage = styled.div`
  &.with-padding {
    padding: 0 120px;
  }

  background-color: #f5f6fa;
`

const mapStateToProps = (state: RootState) => {
  return {
    ProjectCode: selectedProjectCodeSelector(state),
    UserEmail: userEmailSelector(state),
    token: serviceTokenSelector(state),
    filter: selectFilter(state),
    unitList: selectUnitList(state),
    qctypeList: selectQCTypeList(state),
    wbsList: getWbsListSelector(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(mapStateToProps, mapDispatchToProps)(CMUnitFilter)
